import { render, staticRenderFns } from "./login-2.vue?vue&type=template&id=3f3b234a&scoped=true"
import script from "./login-2.vue?vue&type=script&lang=js"
export * from "./login-2.vue?vue&type=script&lang=js"
import style0 from "./login-2.vue?vue&type=style&index=0&id=3f3b234a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b234a",
  null
  
)

export default component.exports